/**
 * StreamingCursor — blinking 2px caret rendered at the end of the actively
 * streaming message body. Pure presentational — visibility is controlled by
 * the parent (ChatMessage) based on streamingMessageId.
 *
 * Animation lives in ion.css (@keyframes ion-cursor-blink). Kept as a
 * dedicated component so the cursor can be portaled or styled independently
 * of the markdown renderer's output.
 */

export function StreamingCursor() {
  return (
    <span
      class="ion-cursor"
      aria-hidden="true"
      role="presentation"
    />
  )
}
